<template>
	<div
		class="border-slate-300 flex rounded-lg border-2 duration-300 focus-within:border-company ltr:flex-row rtl:flex-row-reverse"
	>
		<BaseTextInput
			type="autocomplete"
			:input-class="[
				'border-none rounded-e-lg',
				state.isCountryCodeFocused
					? 'bg-white'
					: 'bg-white hover:bg-slate-100 rounded-s-none duration-300 cursor-pointer font-sans !py-0 !text-lg'
			]"
			theme-type="outlined"
			:class="['z-[11] w-full flex-shrink-0', state.isCountryCodeFocused ? '' : 'max-w-[64px]']"
			:options="CountryDialInfo"
			option-display="flag"
			option-name="name"
			:size="size"
			autocomplete="off"
			:value="selectedCountry"
			:left-icon="!state.isCountryCodeFocused && !areaCode ? 'ph:globe' : undefined"
			@update:value="
				(v) => {
					if (v) {
						state.selectedCountry = v
						emit('update:modelValue', v.dial_code + mobileWithoutAreaCode)
					} else {
						state.selectedCountry = null
						emit('update:modelValue', '')
					}
				}
			"
			@focus="state.isCountryCodeFocused = true"
			@blur="state.isCountryCodeFocused = false"
		>
			<template #option="{ option }">
				<div
					v-if="option"
					class="bg-white text-slate-900 flex w-full cursor-pointer items-center truncate px-3 py-2 text-sm duration-300 hover:bg-slate-50"
				>
					<span class="me-2 flex-shrink-0">
						{{ option.flag }}
					</span>
					<span class="flex-grow truncate">
						{{ option.name }}
					</span>
					<span class="dir-ltr text-slate-600 flex-shrink-0 text-xs">
						{{ option.dial_code }}
					</span>
				</div>
				<div v-else class="hidden"></div>
			</template>
		</BaseTextInput>
		<div v-if="!state.isCountryCodeFocused" class="border-slate-200 my-2 flex-shrink-0 border-e-[2px]" />
		<BaseTextInput
			v-if="!state.isCountryCodeFocused"
			type="number"
			name="mobile"
			class="rounded-0 flex-grow"
			input-class="bg-white border-none"
			:size="size"
			theme-type="outlined"
			:placeholder="$t('mobile')"
			:value="mobileWithoutAreaCode"
			@update:value="(v) => emit('update:modelValue', areaCode + v)"
		/>
	</div>
</template>

<script setup lang="ts">
import CountryDialInfo from "~/assets/country-dial-info.json"

const emit = defineEmits<{
	"update:modelValue": [string]
}>()
const props = withDefaults(
	defineProps<{
		modelValue?: string
		size?: "md" | "lg"
	}>(),
	{
		size: "md"
	}
)

const state = reactive({
	isCountryCodeFocused: false,
	selectedCountry: null as (typeof CountryDialInfo)[number] | null
})

const areaCode = computed(() => {
	const m = String(props.modelValue || "")
	return CountryDialInfo.find((v) => m.includes(v.dial_code))?.dial_code || ""
})

const selectedCountry = computed(
	() => state.selectedCountry || CountryDialInfo.find((v) => v.dial_code == areaCode.value)
)

const mobileWithoutAreaCode = computed(() => {
	const m = String(props.modelValue || "")
	if (!areaCode.value) return m
	return m.replace(areaCode.value, "")
})
</script>
